/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SharedHotelCurrencyAmount } from "./SharedHotelCurrencyAmount";
import {
  SharedHotelCurrencyAmountFromJSON,
  SharedHotelCurrencyAmountFromJSONTyped,
  SharedHotelCurrencyAmountToJSON,
  SharedHotelCurrencyAmountToJSONTyped,
} from "./SharedHotelCurrencyAmount";

/**
 *
 * @export
 * @interface SharedHotelRawRateCharge
 */
export interface SharedHotelRawRateCharge {
  /**
   *
   * @type {string}
   * @memberof SharedHotelRawRateCharge
   */
  name: string;
  /**
   *
   * @type {SharedHotelCurrencyAmount}
   * @memberof SharedHotelRawRateCharge
   */
  value: SharedHotelCurrencyAmount;
}

/**
 * Check if a given object implements the SharedHotelRawRateCharge interface.
 */
export function instanceOfSharedHotelRawRateCharge(
  value: object
): value is SharedHotelRawRateCharge {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  return true;
}

export function SharedHotelRawRateChargeFromJSON(
  json: any
): SharedHotelRawRateCharge {
  return SharedHotelRawRateChargeFromJSONTyped(json, false);
}

export function SharedHotelRawRateChargeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SharedHotelRawRateCharge {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    value: SharedHotelCurrencyAmountFromJSON(json["value"]),
  };
}

export function SharedHotelRawRateChargeToJSON(
  json: any
): SharedHotelRawRateCharge {
  return SharedHotelRawRateChargeToJSONTyped(json, false);
}

export function SharedHotelRawRateChargeToJSONTyped(
  value?: SharedHotelRawRateCharge | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    value: SharedHotelCurrencyAmountToJSON(value["value"]),
  };
}
